import * as ActionTypes from '../actions';
import * as DownloadTypes from '../actions/download';

const defaultDownloadState = { isDownloading: false, id: 0 };
const defaultState = { surveys: [], isFetching: false, download: defaultDownloadState };

export default function posts(state = defaultState, action) {
  switch (action.type) {
    case ActionTypes.SURVEYS_REQUEST:
      return {...state, isFetching: true };
    case ActionTypes.SURVEYS_RECEIVE:
      if (action.payload.meta.page === 1 || action.meta.source === 'init') {
        return { surveys: action.payload.surveys, isFetching: false, download: defaultDownloadState };
      }
      return { surveys: state.surveys.concat(action.payload.surveys), isFetching: false, download: defaultDownloadState };
    case DownloadTypes.ASQ_REPORT_REQUEST:
      return {...state, download: { isDownloading: true, id: action.meta.id } };
    case ActionTypes.API_FAILURE:
    case DownloadTypes.ASQ_REPORT_RECEIVE:
      return {...state, download: defaultDownloadState };
    default:
      return state;
  }
}
